<script setup>
const route = useRoute()
if (!isValidChartUrl(route.params.year, route.params.month)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
const breadCrumbList = getBreadCrumb('chart', 'month', route.params.year, route.params.month)
const nowYearMonth = `${route.params.year}${route.params.month}`
const title = `過去の天気図（${route.params.year}年${Number(route.params.month)}月）`
useCustomMeta('chartMonth', `${route.params.year}年`, `${Number(route.params.month)}月`, '', `/chart/${route.params.year}/${route.params.month}/`)
const { data: calendarData } = await useFetch('/api/past/chart/calendar', { query: { start: nowYearMonth } })
const { data: overviewData } = await useFetch('/api/past/overview', { query: { time: nowYearMonth } })
</script>
<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <PastContent
          :calendar-data="calendarData"
          :year="route.params.year"
          :month="route.params.month"
          :title="title"
        />
      </div>
      <template #main-bottom>
        <div
          v-if="overviewData.summary"
          class="info"
        >
          <PastOverview :body="overviewData.summary" />
        </div>
      </template>
    </NuxtLayout>
  </div>
</template>
<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
